import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseQueryParams, IResponse, IResponsePaginate, RefParams, RefTypeEnum, RefParamsDto } from '@/types';

interface RefParamsQuery extends BaseQueryParams {
  code?: string;
  description?: string;
  search?: string;
  page?: number;
  size?: number;
}

@Injectable({
  providedIn: 'root',
})
export class RefParamsService {
  BASEURL = `${environment.api.paramsUrl}/ref-params`;
  httpClient = inject(HttpClient);

  getRefParams(params?: RefParamsQuery): Observable<IResponsePaginate<RefParams>> {
    return this.httpClient.get<IResponsePaginate<RefParams>>(`${this.BASEURL}`, { params: params as HttpParams });
  }

  getSpecializedRefParams(category?: RefTypeEnum): Observable<IResponse<RefParams>> {
    return this.httpClient.get<IResponse<RefParams>>(`${this.BASEURL}/${category}`);
  }

  getOneRefParams(id: number): Observable<IResponse<RefParams>> {
    return this.httpClient.get<IResponse<RefParams>>(`${this.BASEURL}/${id}`);
  }

  addRefParams(refParams: RefParamsDto): Observable<IResponse<RefParams>> {
    return this.httpClient.post<IResponse<RefParams>>(`${this.BASEURL}`, refParams);
  }

  updateRefParams(id: number, refParams: RefParamsDto): Observable<IResponse<RefParams>> {
    return this.httpClient.put<IResponse<RefParams>>(`${this.BASEURL}/${id}`, refParams);
  }

  deleteRefParams(id: number): Observable<IResponse<RefParams>> {
    return this.httpClient.delete<IResponse<RefParams>>(`${this.BASEURL}/${id}`);
  }
}
